import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';
import axios from 'axios';
import Cookies from 'js-cookie';
import 'survey-core/defaultV2.min.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function SurveyRunner() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [survey, setSurvey] = useState(null);
  const [surveyModel, setSurveyModel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [userName, setUserName] = useState('');
  const [showNamePrompt, setShowNamePrompt] = useState(true);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const storedName = Cookies.get('formAppUserName');
    if (storedName) {
      setUserName(storedName);
      setShowNamePrompt(false);
    }
    
    loadSurvey();
  }, [id]);

  const loadSurvey = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/surveys/${id}`);
      setSurvey(response.data);
      
      const model = new Model(response.data.json);
      model.showProgressBar = 'top';
      model.progressBarType = 'pages';
      model.onComplete.add(handleSurveyComplete);
      
      setSurveyModel(model);
      setLoading(false);
    } catch (err) {
      setError('Failed to load form: ' + err.message);
      setLoading(false);
    }
  };

  const handleNameSubmit = (e) => {
    e.preventDefault();
    if (userName.trim()) {
      Cookies.set('formAppUserName', userName.trim(), { expires: 30 });
      setShowNamePrompt(false);
    }
  };

  const handleSurveyComplete = async (sender) => {
    try {
      const responses = sender.data;
      const storedName = Cookies.get('formAppUserName');
      
      await axios.post(`${API_URL}/responses`, {
        surveyId: id,
        userName: storedName || 'Anonymous',
        responses: responses
      });
      
      setSubmitted(true);
    } catch (err) {
      alert('Failed to submit form: ' + err.message);
    }
  };

  if (loading) {
    return (
      <div className="container">
        <div className="loading">Loading forms...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container">
        <div className="error">{error}</div>
        <button onClick={() => navigate('/')} className="button" style={{ marginTop: '1rem' }}>
          Back to Forms
        </button>
      </div>
    );
  }

  if (showNamePrompt) {
    return (
      <div className="container">
        <h1 className="page-title">Welcome</h1>
        <p className="page-subtitle">Please enter your name to continue</p>
        
        <form onSubmit={handleNameSubmit}>
          <div className="form-group">
            <label className="form-label">Your Name *</label>
            <input
              type="text"
              className="form-input"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              placeholder="Enter your name"
              required
              autoFocus
            />
          </div>
          
          <button type="submit" className="button">
            Continue to Form
          </button>
        </form>
      </div>
    );
  }

  if (submitted) {
    return (
      <div className="container">
        <div className="success">
          <h2 style={{ marginBottom: '1rem' }}>✅ Thank You!</h2>
          <p>Your response has been submitted successfully.</p>
          <p style={{ marginTop: '0.5rem' }}>
            Submitted by: <strong>{Cookies.get('formAppUserName')}</strong>
          </p>
        </div>
        
        <div className="flex-end" style={{ marginTop: '1rem' }}>
          <button 
            className="button button-secondary"
            onClick={() => navigate('/')}
          >
            Back to Forms
          </button>
          <button 
            className="button"
            onClick={() => window.location.reload()}
          >
            Take Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div style={{ marginBottom: '1.5rem' }}>
        <h1 className="page-title">{survey.title}</h1>
        {survey.description && (
          <p className="page-subtitle">{survey.description}</p>
        )}
        <p style={{ color: '#7f8c8d', fontSize: '0.85rem' }}>
          Taking form as: <strong>{Cookies.get('formAppUserName')}</strong>
          {' '}
          <button
            onClick={() => {
              Cookies.remove('formAppUserName');
              window.location.reload();
            }}
            style={{
              background: 'none',
              border: 'none',
              color: '#3498db',
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: '0.85rem',
              padding: 0
            }}
          >
            (Change)
          </button>
        </p>
      </div>
      
      {surveyModel && <Survey model={surveyModel} />}
    </div>
  );
}

export default SurveyRunner;
